import { create } from "zustand";

interface UploadImage {
  certificate: string;
  images: string[];
  setCertificate: (certificate: string) => void;
  setImages: (images: string[]) => void;
}

export const useUploadImagesStore = create<UploadImage>((set) => ({
  images: [],
  certificate: "",
  setImages: (images: string[]): void => {
    set({ images });
  },
  setCertificate: (certificate: string): void => {
    console.log(certificate);

    set((prevState) => ({ ...prevState, certificate }));
  },
}));
